import { render, staticRenderFns } from "./AddAssemblyDetailModal.vue?vue&type=template&id=46b0c468"
import script from "./AddAssemblyDetailModal.vue?vue&type=script&lang=js"
export * from "./AddAssemblyDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports